import { render, staticRenderFns } from "./continueSlider.vue?vue&type=template&id=05cdb5d3&scoped=true&"
import script from "./continueSlider.vue?vue&type=script&lang=js&"
export * from "./continueSlider.vue?vue&type=script&lang=js&"
import style0 from "./continueSlider.vue?vue&type=style&index=0&id=05cdb5d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdb5d3",
  null
  
)

export default component.exports